import React from 'react';
import LayoutMobileBackHeader from '../../../../../Common/Mobile/Layout/BackHeader/LayoutMobileBackHeader';
import ProgressLine from '../../../../../Common/ProgressLine/ProgressLine';
import SignUpConfirmStep from './SignUpConfirmStep';
import LayoutMobileFixedHeight from '../../../../../Common/Mobile/Layout/FixedHeight/LayoutMobileFixedHeight';
import { SIGN_UP_STEPS_COUNT } from '../../../../../../common/constants';

function SignUpConfirmStepMobile() {
  return (
    <LayoutMobileFixedHeight>
      <LayoutMobileBackHeader
        header={<ProgressLine step={2} count={SIGN_UP_STEPS_COUNT} />}
      >
        <SignUpConfirmStep/>
      </LayoutMobileBackHeader>
    </LayoutMobileFixedHeight>
  )
}

export default SignUpConfirmStepMobile